module.exports = __webpack_public_path__ + "static/aid-b9bb943073df2f08c797cf4ed58cbd64.png";